function ss(key) {
  if (typeof sessionStorage === "undefined") return "";
  const v = sessionStorage.getItem(key);
  return v && v !== "null" && v !== "undefined" ? v : "";
}

export function generateSessionId() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
}

export function getCrossDeviceUploadUrl(sessionId, uploadToken) {
  if (!sessionId) return "";
  const origin = process.env.REACT_APP_FRONTEND_URL
    || (typeof window !== "undefined" ? window.location.origin : "");

  if (uploadToken) {
    return `${origin}/ipd-mobile-scan?upload_token=${encodeURIComponent(uploadToken)}&session=${encodeURIComponent(sessionId)}`;
  }

  return `${origin}/ipd-mobile-scan?session=${encodeURIComponent(sessionId)}&org=${encodeURIComponent(ss("ORG_CODE"))}&app=${encodeURIComponent(ss("APP_MODE"))}&key=${encodeURIComponent(ss("USER_ACCESS_KEY"))}&user=${encodeURIComponent(ss("userName"))}&token=${encodeURIComponent(ss("accessToken"))}`;
}
